module.exports = __webpack_public_path__ + "static/media/detail6.e79fb1c8.jpg";